<template>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12" :loading="isLoading?'accent':false">
            <v-toolbar color="primary darken-4" dark flat>
              <v-toolbar-title>Ingresar</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <form @submit.prevent="login" autocomplete="off">
                <v-text-field
                @keyup.enter="login"
                label="Email"
                v-model="email"
                name="login"
                prepend-icon="person"
                type="email"
                ></v-text-field>
                <v-text-field
                @keyup.enter="login"
                id="password"
                label="Contraseña"
                name="password"
                prepend-icon="lock"
                type="password"
                v-model="password"
                ></v-text-field>
              </form>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="primary" @click="login">Ingresar</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>
      <script>
export default {
  data() {
    return {
      email     : "",
      password  : "",
      isLoading : false
    };
  },
  methods: {
    login: function() {
      let email      = this.email;
      let password   = this.password;
      this.isLoading = true;
      this.$store
      .dispatch("login", { email, password })
      .then(() => {
        this.isLoading = false;
        this.$router.push("/tarjas")
      })
      .catch(err => {
        console.log(err)
        this.isLoading = false;
      });
    }
  }
};
</script>
